import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasButtonGroup = ({
  children,
  className,
  orientation = 'horizontal',
  // eslint-disable-next-line no-unused-vars
  sx,
  // eslint-disable-next-line no-unused-vars
  type,
  // eslint-disable-next-line no-unused-vars
  value,
  // eslint-disable-next-line no-unused-vars
  exclusive,
  // eslint-disable-next-line no-unused-vars
  onChange,
  // eslint-disable-next-line no-unused-vars
  disabled,
  ...props
}) => {
  const cornerClasses =
    orientation === 'vertical'
      ? '[&>button]:rounded-none [&>button:first-child]:rounded-t-md [&>button:last-child]:rounded-b-md [&>button:not(:first-child)]:border-t-0'
      : '[&>button]:rounded-none [&>button:first-child]:rounded-l-md [&>button:last-child]:rounded-r-md [&>button:not(:first-child)]:border-l-0'

  return (
    <div
      className={cn('inline-flex', orientation === 'vertical' ? 'flex-col' : 'flex-row', cornerClasses, className)}
      role='group'
      {...props}
    >
      {children}
    </div>
  )
}

AdasButtonGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
}
